import { CacheManager, registeT } from '@mts-fe/utils';
import { i18n } from '@mts/locales/setupI18n';

interface I18nGlobalTranslation {
  (key: string): string;
  (key: string, locale: string): string;
  (key: string, locale: string, list: unknown[]): string;
  (key: string, locale: string, named: Record<string, unknown>): string;
  (key: string, list: unknown[]): string;
  (key: string, named: Record<string, unknown>): string;
}

type I18nTranslationRestParameters = [string, any];

function getKey(namespace: string | undefined, key: string) {
  if (!namespace) {
    return key;
  }
  if (key.startsWith(namespace)) {
    return key;
  }
  return `${namespace}.${key}`;
}

/** @deprecated 请直接使用 t() */
export function useI18n(namespace?: string): {
  t: I18nGlobalTranslation;
} {
  const normalFn = {
    t: (key: string) => {
      return getKey(namespace, key);
    },
    tt: (key: string | string[]) => {
      return key?.toString();
    },
  };

  if (!i18n) {
    return normalFn;
  }

  const { t, ...methods } = i18n.global;

  const tFn: I18nGlobalTranslation = (key: string, ...arg: any[]) => {
    if (!key) return '';

    return (t as (arg0: string, ...arg: I18nTranslationRestParameters) => string)(
      !key.includes('.') && !namespace ? key : getKey(namespace, key),
      ...(arg as I18nTranslationRestParameters),
    );
  };

  return {
    ...methods,
    /** @deprecated 无额外传参的翻译使用 t 函数 */
    t: tFn,
  };
}

// Why write this function？
// Mainly to configure the vscode i18nn ally plugin. This function is only used for routing and menus. Please use useI18n for other places

// 为什么要编写此函数？
// 主要用于配合vscode i18nn ally插件。此功能仅用于路由和菜单。请在其他地方使用useI18n
// export const t = (key: string) => key;

let tFn: (key: string, values?: Recordable) => string;
/** 极简单多语言转换方法 */
const _t = (key: string, values?: Recordable) => {
  if (!key) return '';

  if (!tFn) tFn = i18n?.global?.t;

  return tFn?.(key, values) || key;
};

const globalPrefixes = ['g.', 'gm.', 'common.', 'sys.'];
const globalTranslationCache = new CacheManager();
const translationCache = new CacheManager();
/**
 * 多语言转换方法
 * 缓存策略：基于调用次数
 */
export const t = (key: string, values?: Recordable) => {
  if (!key) return '';

  if (values) return _t(key, values);

  const cacheManager = hasPrefix(key, globalPrefixes) ? globalTranslationCache : translationCache;
  const cached = cacheManager.get(key);
  if (cached) return cached.v;

  const result = _t(key);
  cacheManager.set(key, result);
  return result;
};
registeT(t);

/** 清除指定key的多语言缓存 */
export const cleanTranslationCache = (key: string) => {
  if (!key) return false;

  const cacheManager = hasPrefix(key, globalPrefixes) ? globalTranslationCache : translationCache;
  return cacheManager.delete(key);
};

function hasPrefix(key: string, prefixes: string[]) {
  const c = key[0];
  for (const prefix of prefixes) {
    if (c === prefix[0] && key.startsWith(prefix)) return true;
  }
  return false;
}
